import type { PageOwnershipByLineWithCollaboratorsDropdownContentQuery$variables } from './__generated__/PageOwnershipByLineWithCollaboratorsDropdownContentQuery.graphql.ts';

export const getContentCollaboratorsQueryVariables = ({
	cloudId,
	contentId,
	spaceKey,
	shouldIncludeJobTitle,
}: {
	cloudId: string;
	contentId: string;
	spaceKey: string;
	shouldIncludeJobTitle: boolean;
}): PageOwnershipByLineWithCollaboratorsDropdownContentQuery$variables => ({
	cloudId,
	id: contentId,
	spaceKey,
	first: 2147483647,
	shouldIncludeJobTitle,
});
